import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import React, { useRef, useState } from 'react';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { FlagOutlined, ScheduleOutlined, SoundOutlined } from '@ant-design/icons';
import Style from './style';
import useMapHelper from './helper';
import Documentation from '../../../../components/dashboards/components/OverviewMap/Documentation';
import RiskScore from '../../../../components/dashboards/SupplyChainSummaryProject/components/riskScore';
import OverviewMapControllers from '../../../../components/dashboards/components/OverviewMap/Controllers';

const IconCont = ({
  icon,
  label,
  value,
}) => (
  <div className="cont icon-cont">
    <div className="icon">
      {icon}
    </div>
    <div className="label">
      <label>
        {label}
      </label>
    </div>
    <div className="value">
      <label>
        {value}
      </label>
    </div>
  </div>
);

const SCLMap = ({
  data: { scl = {}, village = null, town = null },
  isSingleSource = false,
  locationId = '',
  mod = '',
  loading = false,
  isOwnData = false,
  allSources = [],
  mode,
  filterKey,
}) => {
  const container = useRef();
  const { t } = useTranslation();
  const [documentationCollapsed, setDocumentationCollapsed] = useState(false);

  const {
    zoomHandler,
    zoomOutHandler,
    moveDownHandler,
    moveUpHandler,
  } = useMapHelper({
    container,
    scl,
    village,
    filterKey,
    town,
    t,
  });

  return (
    <Style id="1d">
      {loading ? <WidgetLoader style={{ zIndex: 1000 }} /> : null}
      <>
        <div className="left-cont">
          <div className="cont info">
            <h1>{t('Mine Site Details')}</h1>
            <div className="items">
              <div className="item">
                <label>{t('Type of mining operations')}</label>
                <h5>{scl.typeOfMiningOperation || '-'}</h5>
              </div>
              <div className="item">
                <label>{t('Operator')}</label>
                <h5>{scl.operator || '-'}</h5>
              </div>
              <div className="item">
                <label>{t('Products')}</label>
                {Array.isArray(scl.products) ? (
                  <div className="tags">
                    {scl.products.map((p, i) => (
                      <Tag color="gold" key={`products-${i}-${p}`} id={`products-${i}-${p}`}>{p}</Tag>
                    ))}
                  </div>
                ) : <h5>-</h5>}
              </div>
            </div>
          </div>
          <div className="cont">
            <h1>{t('Overall Risk')}</h1>
            <RiskScore
              t={t}
              score={{
                score: scl.score || 0,
                totalRisks: scl.totalRisks || 0,
                risksWithScore: scl.risksWithScore || 0
              }}
              showLabel={false}
              showLabelInScore
            />
          </div>
          <IconCont
            icon={<FlagOutlined />}
            label="Monitored Risks"
            value={scl.monitoredRisks || '-'}
          />
          <IconCont
            icon={<SoundOutlined />}
            label="Associated Events"
            value={scl.associatedEvents || '-'}
          />
          <IconCont
            icon={<ScheduleOutlined />}
            label="Proposed Measures"
            value={scl.proposedMeasures || '-'}
          />
        </div>
        <div className="map" ref={container} />
        <Documentation
          mode={mode}
          t={t}
          locationId={locationId}
          isSingleSource={isSingleSource}
          mod={mod}
          collapsed={documentationCollapsed}
          setCollapsed={setDocumentationCollapsed}
          data={scl}
          isOwnData={isOwnData}
          allSources={allSources}
        />
        <OverviewMapControllers
          zoomHandler={zoomHandler}
          moveUpHandler={moveUpHandler}
          zoomOutHandler={zoomOutHandler}
          moveDownHandler={moveDownHandler}
          documentationCollapsed={documentationCollapsed}
        />
      </>
    </Style>
  );
};

export default SCLMap;
